import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useDiscountStore = defineStore("discount", {
    actions: {
        async discountConfigListFetch(payload) {
            let body = null
            if (payload.use !== '') {
                body = {
                    page: {
                        index: payload.index,
                        size: payload.size,
                        sort: "",
                    },
                    filter: {
                        shopUid: payload.shopUid,
                        discountName: payload.discountName,
                        cusTypeUid: payload.cusTypeUid,
                        txType: payload.txType,
                        intStatus: payload.intStatus,
                        "startDate:ge": payload.startDate,
                        "endDate:le": payload.endDate,
                    },
                };
            } else {
                body = {
                    page: {
                        index: payload.index,
                        size: payload.size,
                        sort: "",
                    },
                    filter: {
                        shopUid: payload.shopUid,
                        discountName: payload.discountName,
                        cusTypeUid: payload.cusTypeUid,
                        txType: payload.txType,
                        intStatus: payload.intStatus,
                        "startDate:le": payload.startDate,
                        "endDate:ge": payload.endDate,
                    },
                };

            }

            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/interest-svc/config/discount/list";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async discountConfigInfoFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/interest-svc/config/discount/info/" + payload.uid;
                    const response = http.get(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async discountConfigAddFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                discountName: payload.discountName,
                description: payload.description,
                cusTypeUid: payload.cusTypeUid,
                txType: payload.txType,
                periodMonths: payload.periodMonths,
                startDate: payload.startDate,
                endDate: payload.endDate,
                tiers: payload.tiers,
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/interest-svc/config/discount/new";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async discountConfigUpdateFetch(payload) {
            const body = {
                uid: payload.uid,
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                discountName: payload.discountName,
                description: payload.description,
                cusTypeUid: payload.cusTypeUid,
                txType: payload.txType,
                periodMonths: payload.periodMonths,
                startDate: payload.startDate,
                endDate: payload.endDate,
                tiers: payload.tiers,
                intStatus: payload.intStatus,
                version: payload.version,
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/interest-svc/config/discount/update";
                    const response = http.put(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async discountConfigApproveFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl =
                        "/interest-svc/config/discount/approve/" + payload.uid;
                    const response = http.put(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },
        async discountConfigRevertFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl =
                        "/interest-svc/config/discount/revert/" + payload.uid;
                    const response = http.put(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },
        async discountConfigTerminateFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl =
                        "/interest-svc/config/discount/terminate/" + payload.uid;
                    const response = http.put(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },
        async discountConfigDeleteFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl =
                        "/interest-svc/config/discount/delete/" + payload.uid;
                    const response = http.delete(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },
    },
});